"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.MODELS, (table)=>{
        // nc_dashboards_v2
        table.string('created_by', 20);
        table.string('owned_by', 20);
        table.string('uuid', 255);
        table.string('password', 255);
        table.string('fk_custom_url_id', 20);
        // Indexes
        table.index('uuid');
        table.index('type');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.MODELS, (table)=>{
        // Indexes
        table.dropIndex('uuid');
        table.dropIndex('type');
        // nc_dashboards_v2 columns
        table.dropColumn('created_by');
        table.dropColumn('owned_by');
        table.dropColumn('uuid');
        table.dropColumn('password');
        table.dropColumn('fk_custom_url_id');
    });
};
